module.exports = __webpack_public_path__ + "static/media/balls_banner_150.9b42a165.png";